import { useState } from 'react';
import { MenuItem } from '@mui/material';
import { ButtonDropdown } from 'framework/form';
import {
  WORKFORCE_ANALYTICS_VIEW_BY_LABELS,
  WorkforceAnalyticsViewBy,
} from 'domain/people/workforceAnalytics/constants';

type WorkforceAnalyticsViewBySelectProps = {
  value: WorkforceAnalyticsViewBy;
  onChange: (value: WorkforceAnalyticsViewBy) => void;
};

const VIEW_BY_SOURCE = 'viewBy';

const WorkforceAnalyticsViewBySelect = ({ value, onChange }: WorkforceAnalyticsViewBySelectProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(isMenuOpen => !isMenuOpen);

  const handleChange = (nextValue: WorkforceAnalyticsViewBy) => {
    onChange(nextValue);
    setIsOpen(false);
  };

  return (
    <ButtonDropdown
      source={VIEW_BY_SOURCE}
      label="View by"
      displayedValue={WORKFORCE_ANALYTICS_VIEW_BY_LABELS[value]}
      isOpen={isOpen}
      toggleMenu={toggleMenu}
    >
      {Object.values(WorkforceAnalyticsViewBy).map(viewBy => (
        <MenuItem key={viewBy} selected={viewBy === value} onClick={() => handleChange(viewBy)}>
          {WORKFORCE_ANALYTICS_VIEW_BY_LABELS[viewBy]}
        </MenuItem>
      ))}
    </ButtonDropdown>
  );
};

export default WorkforceAnalyticsViewBySelect;
